// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Libs
import { cn } from '@/common-utils/libraries/tailwind/utils';
// Store & actions
import actionsSession from '@/app/modules/session/api/actionsSession';
import useSessionStore from '@/app/store/session';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
import { Button } from '@/common-utils/components/ui/button';
import Spinner from '@/common-utils/components/renders/spinner/Spinner';
// Common
import ICONS from '@/common-utils/enums/icons';
import RouteUrls from '@/app/root/enums/RouteUrls';
import LOGIN_SCREENS from '@/app/modules/login/enums/LoginScreens';
// Css
import './DeactivateMFAFromLogin.scss';
// Lang
import { nsLogin, nsSession } from '@/app/i18n/namespaces';

/**
 * @param {string} userMail
 * @param {function} exitScreen
 *@returns {JSX} DeactivateMFAFromLogin
 */
function DeactivateMFAFromLogin({ userEmail, exitScreen }) {
    // Store
    const { token } = useSessionStore();

    // State
    const [responseEntity, setResponseEntity] = useState(null);

    // API call
    const onSuccess = () => {
        setResponseEntity('mfa.remove_email_warning');
    };
    const onError = () => {
        setResponseEntity('mfa.remove_send_email_error');
    };
    const sendMfaDeactivationMail = actionsSession.sendMfaDeactivationMail(onSuccess, onError);

    // Functions
    const sendMailToRemoveMFA = () => {
        sendMfaDeactivationMail.mutate({ landingPage: RouteUrls.HOME.url, token });
    };

    return (
        <div className='remove-mfa-from-login'>
            {!responseEntity &&
                <div>
                    <div>
                        <Entity namespace={nsSession} entity='mfa.remove_text_validation' />
                    </div>
                    <div className={cn('mb-4', 'remove-mfa-from-login-information')}>
                        {
                            userEmail ?
                                <div>
                                    <Entity namespace={nsSession} entity='mfa.remove_email_information' className={cn('font-normal')} />
                                    <span className='remove-mfa-email-from-login'>{userEmail}</span>
                                </div>
                                :
                                <Entity namespace={nsSession} entity='mfa.remove_email_missing' />
                        }
                    </div>
                </div>
            }
            {responseEntity &&
                <div className={cn('mb-4', 'remove-mfa-from-login-information')}>
                    <Entity namespace={nsSession} entity={responseEntity} className={cn('font-normal')} />
                </div>
            }
            <div className='grid gap-4 justify-center'>
                {!responseEntity &&
                    <Button
                        variant='primary'
                        entity='button.submit'
                        icon={ICONS.EMAIL}
                        size='lg'
                        onClick={sendMailToRemoveMFA}
                        disabled={sendMfaDeactivationMail.isLoading}
                    />
                }
                <Button
                    variant='link'
                    namespace={nsLogin}
                    entity='back_to_login'
                    icon={ICONS.ARROW_LEFT}
                    onClick={() => exitScreen(LOGIN_SCREENS.NO_MFA_ACCESS)}
                    disabled={sendMfaDeactivationMail.isLoading}
                />
                {sendMfaDeactivationMail.isLoading && <Spinner className={'mt-2'} />}
            </div>
        </div>
    );
}

DeactivateMFAFromLogin.propTypes = {
    userEmail: PropTypes.string,
    exitScreen: PropTypes.func
};

export default DeactivateMFAFromLogin;